module.exports = __webpack_public_path__ + "static/media/DefaultMenuItem.2db18f1a.png";